/* 🤖 this file was generated by svg-to-ts */
export const matIconFormatStrikethrough: {
  name: 'format-strikethrough';
  data: string;
} = {
  name: 'format-strikethrough',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z"/></svg>`
};
